import axios from "axios";

const cancelTokenSource = {};

export const getRssFeed = async (rss) => {
  const res = await axios.get('/api/rss', { params: { rss } });
  return res.data;
};